// extracted by mini-css-extract-plugin
export default {"button":"tooltip__button___2QB3c","icon":"tooltip__icon___2X2nc","content":"tooltip__content___1lA-7","popover":"tooltip__popover___32ZS7"};